module.exports = __webpack_public_path__ + "static/media/basement-2.8e4764c5.jpg";